import Typography from "@material-ui/core/Typography"
import type { Translations } from "../hooks/use-settings-page-translations"
import { makeStyles } from "@material-ui/core"
import { RoleChip } from "./RoleChip"
import { useSettingsPageTranslations } from "../hooks/use-settings-page-translations"

type Membership = {
  fullname: string
  role: string
  isOwner: boolean
  isStandardMember: boolean
  isLimitedMember: boolean
  hasAcceptedInvitation: boolean
}

type SettingsPageHeaderProps = {
  membership: Membership
  translations: Translations
}

export const SettingsPageHeader = ({ translations, membership }: SettingsPageHeaderProps) => {
  const classes = useStyles()
  const formattedTranslations = useSettingsPageTranslations({ name: membership.fullname })
  return (
    <header className={classes.header} data-test="page-header">
      <div className="chipWrapper">
        <RoleChip membership={membership} />
      </div>
      <Typography variant="h4" style={{ marginBottom: 8 }}>
        {formattedTranslations.pageHeader}
      </Typography>
    </header>
  )
}

const useStyles = makeStyles((theme) => ({
  header: {
    display: "flex",
    flexDirection: "column",
    marginBottom: theme.spacing(3),

    [theme.breakpoints.up("sm")]: {
      flexDirection: "row-reverse",
      alignItems: "center",
      justifyContent: "flex-end",
    },

    "& .chipWrapper": {
      marginBottom: theme.spacing(1),
      [theme.breakpoints.up("sm")]: {
        marginBottom: theme.spacing(0.5),
        marginLeft: theme.spacing(1.5),
      },
    },
  },
  pageTitle: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginBottom: theme.spacing(),
    },
  },
}))
